import { useThemeColor } from "@themes/Colors";
import { IContratoOperadora } from "./ContratoOperadora"
import { IVendedor } from "./Vendedor"
import React from "react";

export const linhaDisponibilidades = [
    "Ativa", 
    "Excluída", 
    "Resgatar", 
    "Gaveta",
    "Vendedor",
    "Defeito",
    "Troca DDD",
    "Funcionário",
    "Cortesia"
] as const;

export type LinhaDisponibilidade = typeof linhaDisponibilidades[number];

export default interface ILinha {
    linhaId: number

    contratoOperadoraId: number
    linhaStatusId: number
    vendedorId?: number

    numeroSemMascara: string
    ddd: string

    linhaEmpresa: string
    vozIlimitada: string

    numeroContrato: string

    contratoOperadoraEmpresaNome: string
    contratoOperadoraOperadoraNome: string
    linhaStatusNome: string

    ClienteId: number
    ClienteNome: string

    disponibilidade: LinhaDisponibilidade

    contratoOperadora: IContratoOperadora
    vendedor?: IVendedor
}

export function useLinhaDisponibilidadeColor () {
    const themeColor = useThemeColor();

    const map : {[k in LinhaDisponibilidade]: string} = React.useMemo(() => ({
        "Ativa": themeColor.status.verde,
        "Excluída": themeColor.status.cinza,
        "Resgatar": themeColor.status.vermelho,
        "Gaveta": themeColor.status.azul,
        "Vendedor": themeColor.status.roxo,
        "Defeito": themeColor.status.laranja,
        "Troca DDD": themeColor.status.dourado,
        "Funcionário": themeColor.status.marrom,
        "Cortesia": themeColor.status.verdeClaro,
    }), [themeColor.status.azul, themeColor.status.cinza, themeColor.status.dourado, themeColor.status.laranja, themeColor.status.marrom, themeColor.status.roxo, themeColor.status.verde, themeColor.status.verdeClaro, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}